import React from 'react';
import PropTypes from 'prop-types';

const SvgSelect = ({ active, ...props }) => {
    const fillColor = active ? '#128383' : '#fff';
    const strokeColor = active ? '#fff' : '#343A72';

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="26" fill="none" viewBox="0 0 17 26" {...props}>
            <path fill={fillColor} d="m1 1 15.284 13.552-7.387.605L13.1 23.99l-2.802 1.21-4.076-8.954L1 20.965V1" />
            <path
                stroke={strokeColor}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.25"
                d="m1 1 15.284 13.552-7.387.605L13.1 23.99l-2.802 1.21-4.076-8.954L1 20.965V1"
            />
        </svg>
    );
};

SvgSelect.propTypes = {
    active: PropTypes.bool,
};
SvgSelect.defaultProps = {
    active: false,
};

export default SvgSelect;
